import React, { useEffect, useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import { DeviceSVG } from '../../../components';
import DeviceSection from './forms/sections/DeviceSection';
import { useTranslation } from 'react-i18next';
import { usersService } from '../../../services';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { useClientUIContext } from './context/ClientByIdUIContext';
import UAParser from 'ua-parser-js';
import { palette } from '../../../styles/theme';

export default function ClientDevice () {
    const { t } = useTranslation();
    // Get client Id from url params
    const { id } = useParams();
    const clientId = parseInt(id);

    // State
    const clientUIContext = useClientUIContext();
    const clientUIProps = useMemo(() => {
        return {
            isLoading: clientUIContext?.isLoading,
            setIsLoading: clientUIContext?.setIsLoading,
            clientGeneral: clientUIContext?.clientGeneral,
            setClientGeneral: clientUIContext?.setClientGeneral,
            clientAddress: clientUIContext?.clientAddress,
            setClientAddress: clientUIContext?.setClientAddress
        };
    }, [clientUIContext]);

    const fetchClientById = () => {
        clientUIProps.setIsLoading(true);

        usersService
            .getById(clientId)
            .then(async client => {
                clientUIProps.setClientGeneral(prepareGeneralData(client));
                clientUIProps.setIsLoading(false);

                return false;
            });
    };

    const parseDevice = device => {
        const parsedObj = new UAParser(device?.type?.description).getResult();
        const browser = parsedObj.browser;
        const deviceInfo = parsedObj.device;
        const os = parsedObj.os;
        return {
            ...device,
            type: {
                ...device?.type,
                browser: `${browser?.name || ''} v${browser?.version || ''}`,
                vendor: `${deviceInfo?.vendor || ''}`,
                model: `${deviceInfo?.model || ''}`,
                os: `${os?.name || ''} v${os.version}`
            }
        };
    };

    const prepareGeneralData = (client) => {
        if (!client?.person?.devices) return [];

        return {
            devices: client.person?.devices?.map(device => parseDevice(device))
        };
    };

    // const handleToggleDevice = deviceId => {
    //     const newDevices = clientUIProps.clientGeneral.devices.map(({ ...device }) => {
    //         if (device.id === deviceId) {
    //             device.blocked = device.blocked === 0 ? 1 : 0;
    //         }

    //         return device;
    //     });
    //     clientUIProps.setClientGeneral({ ...clientUIProps.clientGeneral, devices: newDevices });
    // };

    // Functions

    useEffect(() => {
        fetchClientById(clientId);
        // eslint-disable-next-line
    }, []);

    return (
        <Box style={{ backgroundColor: '#FFF', boxShadow: '0px 0px 30px 0px rgba(82, 63, 105, 0.06)' }} width={'100%'} marginTop={'1rem'} padding={'1rem'} >
            {

                <Box
                    gap={'1rem'}>
                    <Box
                        display='flex'
                        justifyContent='space-between'
                        alignItems='center'>
                        <Box display='flex' gap={'8px'}>
                            {<DeviceSVG customStroke={palette.primary[700]} />}
                            <Typography variant='h5'>{t('device.table.title')}</Typography>
                        </Box>
                    </Box>
                    <DeviceSection devices={clientUIProps.clientGeneral.devices} isLoading={clientUIProps.isLoading}/>
                </Box>

            }
        </Box>
    );
}
